/** Culorile hărții orașului, aceleași pe macheta 3D (`strat3d.ts`) și pe
 *  planul 2D (`StratOras2D.tsx`): omul care trece dintr-o vedere în alta
 *  recunoaște aceleași clădiri după ton.
 *
 *  ALB = înălțimea e scrisă în OSM; GRI DESCHIS = verificată din surse
 *  publice; GRI ÎNCHIS = estimată, deci nesigură. */

export const CULORI = {
  osm: 0xffffff,
  verificat: 0xc4c7cb,
  estimat: 0x9ea3a9,
  strada: 0x9ea2a6,
  pietonal: 0xcbc7bf,
  caleFerata: 0xa89f95,
  verde: 0xb7cea0,
  apa: 0xa7c6dd,
  /** Aceeași cu terenul machetei (`RandareSit3D`, `M.teren`), ca placa mare de
   *  sub oraș să nu se vadă unde începe. */
  teren: 0xc3c8bd,
  /** Culoarea orizontului cerului machetei: ceața de la marginea hărții se
   *  pierde în el. */
  ceata: 0xccd9e6,
  /** Conturul clădirilor pe planul 2D: o clădire albă pe hârtia deschisă a
   *  pânzei s-ar citi doar prin el. Pe machetă muchia o dă lumina. */
  contur: 0x8a8f95,
};

export type CheieCuloare = keyof typeof CULORI;

/** Culoarea ca `#rrggbb`, pentru SVG. */
export const culoareCss = (cheie: CheieCuloare): string =>
  `#${CULORI[cheie].toString(16).padStart(6, "0")}`;
